export default __webpack_public_path__ + "static/media/analytics-blue.77e2e7c4.svg";